module.exports = __webpack_public_path__ + "img/Dust-Explosion-Pentagon-min.6d31b316.png";